export default __webpack_public_path__ + "static/appel-2e0e8ce1aca95a1a078d1cbabf29b299.svg";